<template>
  <div>
    <!-- 上下侧边 -->
    <!-- 上 -->
    <div
      v-show="istop"
      class="fixed max-w-[1400px] w-full tar top-0 left-0 flex items-center justify-center mx-auto z-99"
    >
      <van-swipe
        :show-indicators="false"
        :loop="true"
        :autoplay="3000"
        class="h-[20vw] w-full md:h-[150px]"
        vertical
      >
        <van-swipe-item
          class="h-[20vw] w-full md:h-[150px]"
          v-for="(item, index) in slist"
          :key="index"
          @click="handelUrl(item)"
        >
          <img class="w-full h-full" v-lazy="item.logo" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 下 -->
    <div
      v-if="xlist && xlist.length > 0"
      class="fixed max-w-[1400px] w-full tar bottom-0 left-0 flex items-center justify-center mx-auto z-99"
    >
      <van-swipe
        :show-indicators="false"
        :loop="true"
        :autoplay="3000"
        class="h-[20vw] w-full md:h-[150px]"
        vertical
      >
        <van-swipe-item
          class="h-[20vw] w-full md:h-[150px]"
          v-for="(item, index) in xlist"
          :key="index"
          @click="handelUrl(item)"
        >
          <img class="w-full h-full" v-lazy="item.logo" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 侧边 -->
    <div
      v-show="istop && isCbGb && clist && clist.length > 0"
      class="fixed bottom-[15%] text-[#ff0000] right-0 flex items-center justify-center flex-col mx-auto z-99"
    >
      <van-icon
        size="21px"
        name="clear"
        class="posa top-[-10px] left-[-8px] rounded-[50%]"
        @click="handelCbGb"
      />

      <img
        v-for="(item, index) in clist"
        :key="index"
        class="max-w-[60px] max-h-[60px] rounded-[10px] bor m-[5px] w-[18vw] h-[18vw]"
        v-lazy="item.logo"
        alt=""
        @click="handelUrl(item)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue'

const props = defineProps({
  clist: {
    type: Array,
    default: () => []
  },
  xlist: {
    type: Array,
    default: () => []
  },
  slist: {
    type: Array,
    default: () => []
  }
})

const istop = ref(false)
// 获取元素距离视口顶部的距离
function updateDistance() {
  const rect = distanceDisplay.value.getBoundingClientRect() // 获取元素的位置信息
  const distanceFromTop = rect.top

  if (distanceFromTop <= 15) {
    istop.value = true
    // console.log(istop.value)
  } else {
    istop.value = false
    // console.log(istop.value)
  }
}

const distanceDisplay = ref(null)
onMounted(() => {})

const scroll = () => {
  distanceDisplay.value = document.getElementById('distance')
  // console.log(distanceDisplay.value, 'distanceDisplay.value ')

  window.addEventListener('scroll', updateDistance)
  // 初始化显示距离
  updateDistance()
}
onBeforeMount(() => {
  window.removeEventListener('scroll', updateDistance)
})

const isCbGb = ref(true)
const handelCbGb = () => {
  isCbGb.value = !isCbGb.value
}
const handelUrl = (item) => {
  window.open(item.href, '_blank')
}
defineExpose({ scroll })
</script>

<style scoped>
.tar {
  left: 50%;
  transform: translateX(-50%);
}
.sh {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
.bor {
  border: solid 2px red;
}
</style>
